import React from 'react';
import { Carousel } from 'react-bootstrap';
import bannerImage from '../img/envision/banner/aerospace-banner.jpg';

const WhoweareBanner = () => {
  return (
    <div className="hero-area overly-style-1 opacity-point-4" style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Carousel */}
      <Carousel fade interval={3000} controls={false} indicators={false}>
        {/* First Slide */}
        <Carousel.Item>
          <img 
            className="banner-image" 
            src={bannerImage} 
            alt="Aerospace Banner" 
            style={{
              width: '100%',
              height: '100vh', // Ensure it takes the full viewport height
              objectFit: 'cover', // Make the image cover the entire area
              objectPosition: 'center', // Keep the image centered
            }} 
          />
        </Carousel.Item>
        
        {/* Second Slide */}
        <Carousel.Item>
          <img 
            className="banner-image" 
            src={bannerImage} 
            alt="Aerospace Banner" 
            style={{
              width: '100%',
              height: '100vh', // Ensure it takes the full viewport height
              objectFit: 'cover', // Make the image cover the entire area
              objectPosition: 'center', // Keep the image centered
            }} 
          />
        </Carousel.Item>

        {/* Third Slide */}
        <Carousel.Item>
          <img 
            className="banner-image" 
            src={bannerImage} 
            alt="Aerospace Banner" 
            style={{
              width: '100%',
              height: '100vh', // Ensure it takes the full viewport height
              objectFit: 'cover', // Make the image cover the entire area
              objectPosition: 'center', // Keep the image centered
            }} 
          />
        </Carousel.Item>
      </Carousel>

      {/* Content Overlay */}
      <div className="hero-content-1 hero-content-position" style={{ color: '#fff', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <h1 style={{ color: "#fff", fontSize: "48px", fontFamily: 'urbanist, serif' }}>
          ABOUT <span style={{ fontFamily: 'urbanist, serif' }}>IIA</span>
        </h1>
      </div>
    </div>
  );
};

export default WhoweareBanner;
